<template>
    <div class="page-root">
        <div class="nav">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ name: 'INDEX' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item
                    :to="{
                        name: 'CAR_TRAIN',
                        query: {
                            seriesName: carInfo.seriesName
                        },
                        params: {
                            serid: carInfo.seriesId
                        }
                    }"
                    target="_blank"
                >{{carInfo.seriesName}}</el-breadcrumb-item>
                <el-breadcrumb-item>视频说明书</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="v-player" @dblclick="handleVideoDbclk">
                <c-video-player
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="options"
                    class="video-player vjs-custom-skin"
                    @ready="onPlayerReadied"
                    @ended="onPlayerEnd"
                />
                <div class="info">
                    <p class="info-name">{{videoData.name}}</p>
                    <p class="car-name">{{carInfo.seriesName}}</p>
                </div>
            </div>
            <div class="menu">
                <div class="menu-tabs">
                    <p
                        v-for="(item, index) in tabs"
                        class="menu-tabs-item"
                        :class="{'tabs-active': curTab === index}"
                        :key="index"
                        @click="handleChangeTabs(index)"
                    >
                        <span>{{item | parseTab}}</span>
                    </p>
                </div>
                <div class="menu-content">
                    <template v-for="(videos, index) in videoList">
                        <ul
                            v-if="curTab === index"
                            class="video-list"
                            :key="videos.name"
                        >
                            <li
                                v-for="(video, idx) in videos.tag"
                                class="video-item"
                                :key="idx"
                                @click="handleChangeVideos(idx, video)"
                            >
                                <img
                                    src="@/assets/images/bitmap-small.png"
                                    v-real-src="video.image_url"
                                >
                                <p class="video-name">{{video.name}}</p>
                                <p v-if="curVideo === idx && videos.parentIdx === playTab" class="video-status">正在播放</p>
                            </li>
                        </ul>
                    </template>
                </div>
            </div>
        </div>
        <c-qrcode position="SINGLE"/>
    </div>
</template>

<script>
/**
 * @file 视频说明书
 * @author guozhihao02
 */
import request from 'http/request';
import URLS from 'http/URLS';
import mixinLog from '@/mixin/log.js';
import {sendLog} from 'js/log';
import {scrollTop} from 'js/Utils';
import {makeQueryStr} from 'js/core';
import {get} from 'lodash';
import {videoPlayer} from 'vue-video-player';
import 'video.js/dist/video-js.css';
import Qrcode from '@/components/qrcode';

export default {
    mixins: [mixinLog],
    components: {
        'c-video-player': videoPlayer,
        'c-qrcode': Qrcode
    },
    filters: {
        parseTab(val) {
            return val === '外观展示'
                ? '外观'
                : val === '内饰配置'
                    ? '内饰'
                    : val === '前排空间'
                        ? '前排'
                        : val === '后排空间'
                            ? '后排' : val;
        }
    },
    props: {
        serid: String
    },
    data() {
        return {
            options: {
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                autoplay: true,
                muted: false,
                loop: false,
                preload: 'auto',
                language: 'zh-CN',
                aspectRatio: '16:9',
                fluid: true,
                url: '',
                attrib: '',
                poster: require('@/assets/images/bitmap-big.png'),
                notSupportedMessage: '此视频暂无法播放，请稍后再试',
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true
                }
            },
            videoData: {},
            player: null,
            carInfo: {},
            tabs: [],
            videoList: [],
            curTab: 0,
            curVideo: 0,
            playTab: 0
        };
    },
    created() {
        const query = this.$route.query;
        this.carInfo = {
            seriesId: this.serid,
            seriesName: query.sername
        };
        // 兼容低版本路由
        if (query.serid && !this.serid) {
            this.serid = query.serid;
            this.carInfo.seriesId = query.serid;
        }
        this.getVideo();
    },
    methods: {
        getVideo() {
            const {sername, tab = '完整视频', index = 0} = this.$route.query;
            /* eslint-disable fecs-camelcase */
            request(URLS.GETCARPICLIST, {
                series_id: this.serid,
                series_name: sername,
                'tag_name': '视频说明书'
            })
                .then(res => {
                    // console.log(res, 'video')
                    const videoList = get(res, 'Result.instructions[0].category1[0].category2', []);
                    this.videoList = videoList;
                    // 如果视频说明书第一个不为完整视频，则不显示改模块
                    const tabs = videoList.map((v, i) => {
                        v.parentIdx = i;
                        return v.name;
                    });
                    const curTab = tabs.indexOf(tab) < 0 ? 0 : tabs.indexOf(tab);
                    const idx = +index >= videoList[curTab].tag.length
                        ? 0 : +index;
                    const videoData = videoList[curTab].tag[idx];
                    this.tabs = tabs;
                    this.curTab = curTab;
                    this.playTab = curTab;
                    this.curVideo = idx;
                    this.$nextTick(() => {
                        this.changeVideos(idx, videoData);
                    });
                })
                .catch(err => {});
            /* eslint-enable fecs-camelcase */
        },
        handleChangeTabs(index) {
            if (this.curTab !== index) {
                this.curTab = index;
                this.eleScrollTop(index === this.playTab ? this.curVideo : 0);
                this.sendLog('change_tabs', {
                    pos: index,
                    tabName: this.tabs[index]
                });
            }
        },
        handleChangeVideos(index, video) {
            if (this.playTab !== this.curTab || this.curVideo !== index) {
                this.playTab = this.curTab;
                this.curVideo = index;
                this.changeVideos(index, video);
                this.sendLog('change_videos', {
                    pos: index,
                    tabName: this.tabs[this.curTab],
                    videoName: video.name
                });
            }
        },
        changeVideos(index, video) {
            this.videoData = video;
            this.player.src(video.pub_video_url);
            this.player.poster(video.image_url);
            this.player.play();
            this.modifyUrl({
                index: index,
                tab: this.tabs[this.curTab]
            });
            if (this.curTab === this.playTab) {
                this.eleScrollTop(index);
            }
        },
        eleScrollTop(index) {
            const container = document.querySelector('.menu-content');
            const {offsetTop = ''} = document.querySelectorAll('.video-item')[index] || {};
            if (offsetTop !== '') {
                scrollTop(container, container.scrollTop, offsetTop, 500);
            }
        },
        onPlayerEnd() {
            // 说明该tab下视频已经播放完成
            if (this.videoList[this.playTab].tag.length - 1 <= this.curVideo) {
                // 尚未有tab未播放，切换到下一个tab
                if (this.tabs.length - 1 > this.playTab) {
                    this.curTab = this.playTab + 1;
                    this.playTab = this.playTab + 1;
                    this.curVideo = 0;
                }
                else {
                    return;
                }
            }
            else {
                this.curVideo = this.curVideo + 1;
            }
            this.$nextTick(() => {
                this.changeVideos(
                    this.curVideo,
                    this.videoList[this.playTab].tag[this.curVideo]
                );
            });
        },
        onPlayerReadied(e) {
            this.player = e;
            this.player.src(this.videoData.pub_video_url);
            this.player.poster(this.videoData.image_url);
        },
        handleVideoDbclk() {
            if (!!(document.fullscreen
                || document.mozFullScreen
                || document.webkitIsFullScreen
                || document.webkitFullScreen
                || document.msFullScreen)) {
                if (this.player.el_.exitFullscreen) {
                    this.player.el_.exitFullscreen();
                }
                else if (this.player.el_.mozCancelFullScreen) {
                    this.player.el_.mozCancelFullScreen();
                }
                else if (this.player.el_.webkitExitFullscreen) {
                    this.player.el_.webkitExitFullscreen();
                }
                else if (this.player.el_.msExitFullscreen) {
                    this.player.el_.msExitFullscreen();
                }
                else if (this.player.exitFullscreen) {
                    this.player.exitFullscreen();
                }
            }
            else {
                if (this.player.el_.requestFullscreen) {
                    this.player.el_.requestFullscreen();
                }
                else if (this.player.el_.mozRequestFullScreen) {
                    this.player.el_.mozRequestFullScreen();
                }
                else if (this.player.el_.webkitRequestFullscreen) {
                    this.player.el_.webkitRequestFullscreen();
                }
                else if (this.player.el_.msRequestFullscreen) {
                    this.player.el_.msRequestFullscreen();
                }
            }
        },
        modifyUrl(query) {
            if (!query) {
                return;
            }
            const urlParams = {
                ...this.$route.query,
                ...query
            };
            // 静默修改地址
            if (window.history && history.pushState) {
                history.replaceState(
                    null,
                    null,
                    window.location.href.split('?')[0] + `?${makeQueryStr(urlParams)}`
                );
            }
            // 如果不支持静默修改地址
            // 调用 vue-router，会重新created组件
            else {
                this.$router.push({
                    query: urlParams
                });
            }
        },
        sendLog(key, params) {
            sendLog(`video_intro_${key}`, {
                ...this.carInfo,
                ...(params || {})
            });
        }
    }
};
</script>

<style lang="less" scoped>
.page-root {
    .nav {
        margin: 30px 0;
        .el-breadcrumb {
            font-size: 16px;
        }
        /deep/ .el-breadcrumb__item {
            cursor: pointer;
            .el-breadcrumb__inner {
                color: #333;
                &.is-link {
                    font-weight: 400;
                }
                &:hover {
                    color: #333;
                }
            }
            &[aria-current="page"] .el-breadcrumb__inner {
                color: #333;
                cursor: default!important;
                &:hover {
                    color: #333;
                }
            }
        }
    }
    .container {
        display: flex;
    }
    .v-player {
        position: relative;
        width: 750px;
        height: 423px;
        /deep/ .video-js {
            width: 750px;
            height: 423px;
            font-size: 10px;
            background-color: transparent;
            .vjs-poster {
                outline: none!important;
                background-color: transparent;
            }
            video,
            button,
            .vjs-menu-item {
                outline: none!important;
            }
            .vjs-big-play-button {
                position: absolute;
                top: 50%;
                left: 50%;
                width: 80px;
                height: 80px;
                border: none;
                line-height: 80px;
                text-align: center;
                border-radius: 80px;
                background-color: rgba(0, 0, 0, .4);
                background-image: url("~assets/images/play.svg");
                background-repeat: no-repeat;
                background-position: center;
                background-size: 50px;
                transform: translate(-50%, -50%);
                &:hover {
                    background-color: rgba(0, 0, 0, .6);
                }
            }
            .vjs-playback-rate.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button {
                position: relative;
                &::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    background-color: transparent;
                }
            }
        }
        .info {
            color: #333333;
            &-name {
                margin-top: 24px;
                font-size: 32px;
                line-height: 32px;
            }
            .car-name {
                font-size: 14px;
                margin-top: 10px;
            }
        }
    }
    .menu {
        margin-left: 42px;
        .menu-tabs {
            width: 407px;
            padding-right: 24px;
            display: flex;
            font-size: 20px;
            justify-content: space-between;
            line-height: 20px;
            padding-bottom: 22px;
            border-bottom: 1px solid #EEEEEE;
            color: #333333;
            &-item {
                position: relative;
                cursor: pointer;
                &::after {
                    content: '';
                    position: absolute;
                    opacity: 0;
                    width: 8px;
                    height: 8px;
                    right: -9px;
                    top: -4px;
                    transition: opacity .1s linear;
                    background-image: url(~images/tabs/active.svg);
                }
                &.tabs-active {
                    &::after {
                        opacity: 1;
                    }
                }
            }
        }
        .menu-content {
            margin-top: 14px;
            height: 365px;
            overflow-y: scroll;
        }
        .video-list {
            position: relative;
            overflow: hidden;
        }
        .video-item {
            position: relative;
            float: left;
            width: 180px;
            height: 135px;
            font-size: 14px;
            margin: 0 20px 10px 0;
            cursor: pointer;
            &:nth-child(2n) {
                margin-right: 0;
            }
            img {
                width: 100%;
                height: 101px;
            }
            .video-name {
                margin-top: 10px;
                line-height: 14px;
                color: #333333;
            }
            .video-status {
                user-select: none;
                position: absolute;
                width: 100%;
                height: 101px;
                line-height: 101px;
                text-align: center;
                top: 0;
                color: #FFFFFF;
                background:  rgba(0,0,0,.32);
            }
        }
    }
}
</style>